/** The URL path for the preview app, without leading or trailing slash. */
export const previewPath = 'preview-app';
